import CoursePurchased from '../feature/Courses/CoursePurchased'

const CoursePurchasedPage = () => {
    return <CoursePurchased />
}

export default CoursePurchasedPage